import React from 'react'
import FormattedPhoneNumber from 'transfix-ui/components/FormattedPhoneNumber'
import { Box } from 'transfix-ui/core'

interface ILaneAlertAdditionalSubscriberProps {
  userId: number | string
  firstName: string
  lastName: string
  phoneNumber?: string
  phoneNumberExt?: string
  email?: string
}

const LaneAlertAdditionalSubscriber = React.memo<ILaneAlertAdditionalSubscriberProps>(
  ({ email, firstName, lastName, phoneNumber, phoneNumberExt, userId }) => {
    return (
      <Box pt={2}>
        <Box>
          <a href={`/users/${userId}`} target='_blank' rel='noreferrer'>
            {firstName} {lastName}
          </a>
        </Box>
        <Box>
          {phoneNumber && (
            <FormattedPhoneNumber phoneNumber={phoneNumber} phoneExtension={phoneNumberExt} />
          )}
          {email && (
            <>
              &nbsp;&middot;&nbsp;<a href={`mailto:${email}`}>{email}</a>
            </>
          )}
        </Box>
      </Box>
    )
  }
)

export default LaneAlertAdditionalSubscriber
